function setupTable(el) {
  const headers = Array
    .from(el.querySelectorAll('thead th'))
    .map(th => th.textContent.trim());

  el.querySelectorAll('tbody tr').forEach(row => {
    row.querySelectorAll('td').forEach((td, i) => {
      if (headers[i]) {
        td.setAttribute('data-label', headers[i]);
      }
    });
  });
}

/**
 * Set up tables in the container.
 *
 * @param {HTMLElement} container
 */
function setupTables(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll('table.responsive-stacking')
  existingEls.forEach((el) => {
    setupTable(el)
  })

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) {
          return
        }

        node.querySelectorAll('table.responsive-stacking').forEach((el) => {
          setupTable(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

export { setupTables }
